<template>
  <div>
    <SCheckbox
      :label="`${termsText} this item, you acknowledge to arrange both payment and delivery details with your transaction partner.`"
      @change="$emit('check', $event)"
      :input="checkBox"
      :data-cy="dataCy"
      class="terms"
    />
  </div>
</template>

<script>
import SCheckbox from "@/components/atoms/SCheckbox";
import UserHelperVue from "../../mixins/UserHelper.vue";
import item_type from "@/enum/item-type";
export default {
  name: "ResponsabilityTerms",
  props: {
    checkBox: { default: false },
    itemType: null,
    posterId: null,
    dataCy: null,
  },
  mixins: [UserHelperVue],
  components: {
    SCheckbox,
  },
  computed: {
    termsText() {
      if (this.loggedUser.id !== this.posterId) {
        if (
          item_type.GIVE === this.itemType ||
          item_type.LEND === this.itemType
        ) {
          return "By requesting ";
        } else {
          return "By offering ";
        }
      } else {
        if (
          item_type.GIVE === this.itemType ||
          item_type.LEND === this.itemType
        ) {
          return "By accepting the request for ";
        } else {
          return "By accepting the offer of ";
        }
      }
    },
  },
};
</script>

<style lang="scss">
.terms .dark-color {
  font-weight: normal;
  font-size: 14px !important;
  line-height: 20px;
  letter-spacing: 1.25px;
  color: $black-sub-color !important;
  margin-left: 2px;
  text-align: left;
}
.terms label {
  display: flex;
  flex-wrap: nowrap;
  text-align: initial;
  align-items: center;
}
.terms .check {
  border: 1px solid $primary !important;
}
</style>
